module.exports = __webpack_public_path__ + "img/woo.cc3ef8e7.svg";